module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/modules/_library.js
// module id = 38
// module chunks = 0